import { render, staticRenderFns } from "./ItemsPreview.vue?vue&type=template&id=c7dc51cc"
import script from "./ItemsPreview.vue?vue&type=script&lang=js"
export * from "./ItemsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports